var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSearch = function SvgSearch(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.3,
    d: "M6.628 2.667a3.962 3.962 0 0 1 3.011 6.54l.165.165h.482l3.047 3.047-.914.915-3.048-3.048v-.481l-.164-.165a3.962 3.962 0 1 1-2.578-6.973m0 1.219a2.73 2.73 0 0 0-2.742 2.743 2.73 2.73 0 0 0 2.742 2.743 2.73 2.73 0 0 0 2.743-2.743 2.73 2.73 0 0 0-2.743-2.743"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSearch);
export { ForwardRef as ReactComponent };